import {
  sqItemTableDefinitionStore,
  sqItemTableEditorStore,
  sqScalingTableDefinitionStore,
  sqScalingTableEditorStore,
} from '@/core/core.stores';
import type { EditorType } from '@/tableDefinitionEditor/tableDefinition.types';

export const getTableDefinitionStore = (editorType: EditorType) => {
  switch (editorType) {
    case 'ITEM':
      return sqItemTableDefinitionStore;
    case 'SCALING':
      return sqScalingTableDefinitionStore;
    default:
      throw new Error(`Unknown editor type: ${editorType}`);
  }
};

export const getTableEditorStore = (editorType: EditorType) => {
  switch (editorType) {
    case 'ITEM':
      return sqItemTableEditorStore;
    case 'SCALING':
      return sqScalingTableEditorStore;
    default:
      throw new Error(`Unknown editor type: ${editorType}`);
  }
};
